import { handleResponse } from './default'

const base = process.env.AM_BASE_URL || '';
const httpContentType = 'application/json; charset=utf-8';
const headers = {};

const apiGet = path => fetch(path, {
        credentials: 'include',
        headers
    })
    .then(handleResponse);

const apiPost = (path,body) => fetch(path, {
        method: 'post',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
            'Content-Type': httpContentType,
            ...headers
        }
    })
    .then(handleResponse);

const apiPut = (path,body) => fetch(path, {
        method: 'put',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
            'Content-Type': httpContentType,
            ...headers
        }
    })
    .then(handleResponse);

function setSessionId(id) {
    headers.SessionId = id;
}

function getTransactions(days = 90) {
    return apiGet(base + '/TransactionHistory/Data?period=' + days);
}

function authenticate(freeTrial) {
    return apiGet(base + '/OneBarAuthentication?json=1' + (freeTrial ? '&loginType=2' : ''));
}

function getMenu() {
    return apiGet(base + '/Menu');
}

function getUser() {
    return apiGet(base + '/User');
}

function getNotifications() {
    return apiGet(base + '/Notifications');
}

function getPendingItems() {
    return apiGet(base + '/PendingItems');
}

function iaPartitionEligibility(acctId) {
    return apiPost(base + '/IaPartition/Eligibility', { "accountId": acctId });
}

function iaPartitionSignUp(acctId) {
    return apiPost(base + '/IaPartition/SignUp', { "accountId": acctId });
}

function iaPartitionCreate(params) {
    return apiPost(base + '/IaPartition', params);
}

function submitDocument(endpoint, data) {
    const url = endpoint ? endpoint : base + '/DocumentSubmission';
    return apiPost(url, data);
}

function setLanguage(lang) {
    console.debug('set am language', lang);
    return apiPut(base + '/Language', { lang: lang });
}

function tickleSession() {
    return apiPut(base + '/User/Tickle');
}

function amConfiguration(acctId, configs) {
    return apiPost(base + '/AmConfiguration', { "accountId": acctId, "configs": configs });
}

function getMonthlyActStmtPDF({accounts, period, fromDate, toDate, reportDate}) {
    const data = {
        accounts: accounts,
        format: 9,
        fromDate: fromDate,
        toDate: toDate,
        reportDate: reportDate,
        language: 'en',
        period: period,
        statementCategory: 'DEFAULT_STATEMENT',
        statementType: 'DEFAULT_ACTIVITY'
    }
    return apiPost(base + '/Statements/Run', data);
}

const amApi = {
    authenticate,
    getMenu,
    setLanguage,
    getMonthlyActStmtPDF,
    getNotifications,
    getPendingItems,
    getTransactions,
    getUser,
    tickleSession,
    setSessionId,
    submitDocument,
    iaPartitionEligibility,
    iaPartitionSignUp,
    iaPartitionCreate,
    amConfiguration
}

export default amApi;

window.amApi = amApi;